import * as React from "react";
import "../../gatsby-browser.js";

import Navbar from "../component/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import ContactUs from "../static/img/ContactUs.svg";
import MetaTags from "../component/MetaTags.jsx";

import { motion } from "framer-motion";
import PhoneInput from "react-phone-number-input";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import "react-notifications/lib/notifications.css";
import "react-phone-number-input/style.css";

class Contact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone: "",
      interest: "",
      message: "",
      loading: false,
    };
  }

  getName = (e) => {
    this.setState({ name: e.target.value });
  };

  getEmail = (e) => {
    this.setState({ email: e.target.value });
  };

  getPhone = (value) => {
    this.setState({ phone: value });
  };
  getInterest = (e) =>{
    this.setState({ interest: e.target.value }); 
  };
  getMessage = (e) => {
    this.setState({ message: e.target.value });
  };

  postContact = async () => {
    const { name, email, phone,interest, message } = this.state;

    // Basic validations
    if (!name) {
      NotificationManager.error("Name cannot be empty");
      return;
    }
    if (!email) {
      NotificationManager.error("Email cannot be empty");
      return;
    }
    if (!phone) {
      NotificationManager.error("Phone number cannot be empty");
      return;
    }
    if (!interest) {
      return NotificationManager.error("Please select an option");
    } 

    if (!message) {
      NotificationManager.error("Message cannot be empty");
      return;
    }

    this.setState({ loading: true });

    try {
      const formData = new FormData();

      // ✅ Google Form field mapping
      formData.append("entry.1102309209", name);     // Name
      formData.append("emailAddress", email);       // Email
      formData.append("entry.774180726", phone);    // Phone
      formData.append("entry.1793295208", interest); // 🔥 Dropdown (REPLACE ID)
      formData.append("entry.371784238", message);  // Message

      await fetch(
        "https://docs.google.com/forms/d/e/1FAIpQLScNamc82zH0EVR6CgCcB0WRM-NSm90DeGW2_uGfDK3Oj66wpg/formResponse",
        {
          method: "POST",
          mode: "no-cors",
          body: formData,
        }
      );

      this.setState({
        name: "",
        email: "",
        phone: "",
        interest:"",
        message: "",
        loading: false,
      });

      NotificationManager.success("Message has been sent successfully!");
    } catch (error) {
      this.setState({ loading: false });
      NotificationManager.error("Oops! Something went wrong.");
    }
  };

  render() {
    const pageVariants = {
      initial: { opacity: 0 },
      in: { opacity: 1 },
      out: { opacity: 0 },
    };

    const { name, email, phone,interest, message, loading } = this.state;

    return (
      <>
        <Navbar />

        <motion.div
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
        >
          {/* Header */}
          <section id="howwedo" className="howwedo">
            <div align="center">
              <h1 className="light-text">
                Contact <span className="highlighted-text">Us</span>
              </h1>
              <img className="contact-banner" src={ContactUs} alt="Contact Us" />
            </div>
          </section>

          {/* Form */}
          <div className="row">
            <div className="col-sm-12 contact-form">
              <br />

              <div className="row">
                <div className="col-md-6">
                  <label>Full Name</label>
                  <input
                    className="form-control input-fields"
                    placeholder="Enter Name"
                    value={name}
                    onChange={this.getName}
                  />
                  <br />
                </div>

                <div className="col-md-6">
                  <label>Email</label>
                  <input
                    type="email"
                    value={email}
                    className="form-control input-fields"
                    placeholder="Enter Email"
                    onChange={this.getEmail}
                  />
                </div>

                <div className="col-md-6">
                  <br />
                  <label>Mobile / Phone</label>
                  <PhoneInput
                    className="form-control input-fields"
                    placeholder="Enter phone number"
                    value={phone}
                    onChange={this.getPhone}
                  />
                </div>

                <div className="col-md-6">
                  <br />
                  <label>What do you want to learn?</label>
                  <select
                    className="form-control input-fields"
                    value={interest}
                    onChange={this.getInterest}
                  >
                    <option value="">-- Select an option --</option>
                    <option value="I want to Learn Japanese">I want to Learn Japanese</option>
                    <option value="I want to Learn German">I want to Learn German</option>
                    <option value="I want to Learn French">I want to Learn French</option>
                    <option value="I want to Learn Coding">I want to Learn Coding</option>
                    <option value="I have other query">I have other query</option>
                  </select>
                </div>

                <div className="col-sm-12">
                  <br />
                  <label>Message</label>
                  <textarea
                    rows="6"
                    value={message}
                    className="form-control input-fields"
                    onChange={this.getMessage}
                  />
                </div>
              </div>

              <br />

              <div align="center">
                <button
                  className="btn btn-send"
                  onClick={this.postContact}
                  disabled={loading}
                >
                  {loading ? "SENDING..." : "SEND MESSAGE"}
                </button>
              </div>
            </div>
          </div>

          <Footer />
        </motion.div>

        <NotificationContainer />
        <MetaTags
          title="Contact Us | Koderbox"
          description="Get in touch with Koderbox for foreign language courses, coding classes, or custom software development. We're here to help."
          path="/contactus/"
        />
      </>
    );
  }
}

export default Contact;
